import { useEffect, useState } from "react"
import { useIntl } from "react-intl"
import { useThemeMode } from "../../../../_metronic/partials"
import Category from "./add-board-meeting-tabs/Category"
import Schedule from "./add-board-meeting-tabs/Schedule"
import Participants from "./add-board-meeting-tabs/Participants"
import Agenda from "./add-board-meeting-tabs/Agenda"
import Review from "./add-board-meeting-tabs/Review"

import { useSearchParams } from "react-router-dom"

export default function AddBoardMeetingForm() {
    const [searchParams] = useSearchParams()
    const meeting = searchParams.get('meetingId')
    const type = searchParams.get('type')
    const { formatMessage } = useIntl()
    const { mode } = useThemeMode()
    const [meetingCategory, setMeetingCategory] = useState<string>('');
    const [sidebar, setSidebar] = useState(1);
    const [meetingId, setMeetingId] = useState<string>('')
    const [meetingType, setMeetingType] = useState<string>('')
    const [isOrganizer, setIsOrganizer] = useState(true)
    const sidebarOptions = [
        { tabTitle: formatMessage({ id: 'Category' }), id: 1 },
        { tabTitle: formatMessage({ id: 'Schedule' }), id: 2 },
        { tabTitle: formatMessage({ id: 'Participants' }), id: 3 },
        { tabTitle: formatMessage({ id: 'Agenda' }), id: 4 },
        { tabTitle: formatMessage({ id: 'Review' }), id: 5 },
    ]
    useEffect(() => {
        if (meeting)
            setMeetingId(meeting)
        if (type)
            setMeetingType(type)
    }, [])  // eslint-disable-line react-hooks/exhaustive-deps
    return <>
        <div className='d-flex flex-md-row flex-column mt-4'>
            <div
                className='mb-9 sidebar-investor-db col-md-1 d-none d-md-flex '
                style={{ width: '14%' }}
            >
                {sidebarOptions.map((sideTab) => (
                    <ul className='text-muted text-active-primary d-md-flex flex-column d-none align-items-left p-0 m-0 cursor-pointer '>
                        <li
                            className={`nav-link text-active-primary py-3 ps-3 d-flex align-items-center ${sidebar === sideTab.id
                                ? '  border-top-0 border border-bottom-0 border-right-0 border-left-3 border-primary text-primary border-5'
                                : ''
                                }`}
                            onClick={() => { if (isOrganizer) setSidebar(sideTab.id) }}
                        >
                            {formatMessage({ id: sideTab.tabTitle })}
                        </li>
                    </ul>
                ))}
            </div>
            <div
                className='mb-2 sidebar-investor-db col-md-1 d-flex d-md-none'
                style={{ width: '100%' }}
            >
                <div
                    className='d-md-none d-flex'
                    style={{
                        display: 'flex',
                        overflowX: 'scroll',
                        whiteSpace: 'nowrap',
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none',
                    }}
                >
                    {sidebarOptions.map((sideTab) => (
                        <ul
                            key={sideTab.id}
                            className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent mt-0 flex-nowrap mobile-tab-both my-md-0 mb-2 d-md-none'
                            style={{ display: 'flex', flexWrap: 'nowrap' }}
                        >
                            <li
                                className={`nav-link text-active-primary py-3 ps-3 d-flex align-items-center ${sidebar === sideTab.id
                                    ? 'border-top-0 border border-left-0 border-right-0 border-bottom-3 border-primary text-primary border-5'
                                    : ''
                                    }`}
                                onClick={() => { if (isOrganizer) setSidebar(sideTab.id) }}
                            >
                                {formatMessage({ id: sideTab.tabTitle })}
                            </li>
                        </ul>
                    ))}
                </div>
            </div>

            <div
                className={`p-6 rounded-2 w-100 overflow-y-auto ${mode !== 'dark' ? 'bg-white' : ''}`}
                style={{ background: '#1e1e2d', height: 'calc(100vh - 180px)' }}
            >
                {sidebar === 1 && (
                    <Category setSidebar={setSidebar} meetingCategory={meetingCategory} setMeetingCategory={setMeetingCategory} meetingId={meeting} meetingType={meetingType} />
                )}
                {sidebar === 2 && (
                    <Schedule setSidebar={setSidebar} meetingCategory={meetingCategory} setMeetingId={setMeetingId} meetingId={meetingId} setMeetingType={setMeetingType} />
                )}
                {sidebar === 3 && (
                    <Participants setSidebar={setSidebar} meetingId={meetingId} setIsOrganizer={setIsOrganizer} meetingType={meetingType} />
                )}
                {sidebar === 4 && (
                    <Agenda setSidebar={setSidebar} meetingId={meetingId} meetingType={meetingType} />
                )}
                {sidebar === 5 && (
                    <Review setSidebar={setSidebar} meetingId={meetingId} />
                )}
            </div>
        </div>
    </>
}